import { CallbackModalComponent } from './../../achelos-iot/modals/callback-modal/callback-modal.component';
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap';
import { SuccessModalComponent } from '../../achelos-iot/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../achelos-iot/modals/error-modal/error-modal.component';
import { delay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {InfoModalComponent} from '../../achelos-iot/modals/info-modal/info-modal.component';

@Injectable()
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;
    bsModalRef: any;

    constructor(private router: Router,
        private modalService: BsModalService) {
        // clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next();
                }
            }
        });
    }

    success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
    }

    successModal(message: string) {
        const initialState = {
            message
        };
        this.bsModalRef = this.modalService.show(SuccessModalComponent, { initialState });
    }

    callbackModal(message: string, operationName: string, callback: () => any) {
        const initialState = {
            message,
            operationName,
            callback
        };
        this.bsModalRef = this.modalService.show(CallbackModalComponent, { initialState });
    }

    error(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
        // clear alert after x seconds
        Observable.of(this.subject).pipe(
            delay(environment.mainPageRefreshInterval)
        ).subscribe(gna =>
            this.subject.next()
        );

        Observable.create(x => {

        }).delay(2000).subscribe();


    }

    errorModal(error: string, operationName: string) {
        const successes = [];
        const errors = [error];
        const initialState = {
            errors,
            successes,
            operationName,
        };
        this.bsModalRef = this.modalService.show(ErrorModalComponent, { initialState });
    }

    errors(errors: any[], successes: any[], operationName: string, keepAfterNavigationChange = false, errorTitle?: string) {

        const initialState = {
            errors,
            successes,
            operationName,
            errorTitle

        };
        this.bsModalRef = this.modalService.show(ErrorModalComponent, { initialState });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

  infoModal(information: string) {
    const initialState = {
      information
    };
    this.bsModalRef = this.modalService.show(InfoModalComponent, { initialState });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/alert.service.ts